import { useMemo } from 'react';
import { useMe } from './data.js';
import { BEGRIFFE } from '../../api/src/pakete/kern/begriffe.js';

/**
 * Begriffe der Firma (Wörterbuch aus /api/me: Kern → Branchenpaket → Verwaltung), z. B. `b('baustelle')` → «Objekt»
 * bei einer Elektro-Firma. Solange nichts geladen ist (Anmeldung, offline beim ersten Start), gilt der Kern-Standard –
 * dieselbe Datei wie in der API.
 * @returns {(schluessel: string) => string}
 */
export function useBegriffe() {
  const eigen = useMe().data?.mandant?.begriffe;
  return useMemo(() => (k) => eigen?.[k] || BEGRIFFE[k] || k, [eigen]);
}
